import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { FilterConfigView } from "../filter-config.view";

@Component({
    selector: "save-filter",
    templateUrl: "./save-filter-config.view.html",
    providers: []
})
export class SaveFilterConfigView extends FilterConfigView {
}
